<template>
  <article class="article-block-farming">
    <a href="/" :aria-label="aria">
      <div class="article-block-farming__shape">
        <div class="article-block-farming__shape--logo">
          <LogoSVG />
        </div>
      </div>
      <div class="article-block-farming__header">
        <h3 :class="{ makeInvisible: isActive }">
          <TextHeading variant="lg">{{ title }}</TextHeading>
        </h3>
      </div>
    </a>
    <div class="article-block-farming__sharer">
      <span
        :class="{ makeInvisible: isActive }"
        class="article-block-farming__text"
        >{{ date }}</span
      >
      <BaseButton
        class="article-block-farming__button"
        variant="white"
        rounded="full"
        @click="toggleActive"
        :class="{ makeInvisible: isActive }"
        aria-label="Share this Farming Article"
      >
        <BaseIcon name="share" size="18"></BaseIcon>
      </BaseButton>
      <ShareLinksFarming
        :isActive="this.isActive"
        @toggled="toggleActive"
      ></ShareLinksFarming>
    </div>
    <div class="article-block-farming__hover"></div>
  </article>
</template>

<script>
import ShareLinksFarming from './ShareLinksFarming.vue'
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import TextHeading from '../elements/TextHeading.vue'
import LogoSVG from '@/assets/svg/shapes/logo.svg?inline'
export default {
  name: 'CardArticleFarming',
  components: {
    LogoSVG,
    TextHeading,
    BaseButton,
    BaseIcon,
    ShareLinksFarming
  },
  props: {
    title: {
      type: String,
      default: 'Article title goes here'
    },
    date: {
      type: String,
      default: 'Today'
    },
    aria: {
      type: String,
      default: 'Read this Farming Article'
    }
  },
  data() {
    return {
      isActive: false,
      makeActive: false
    }
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    }
  }
}
</script>

<style lang="postcss">
.makeInvisible {
  @apply opacity-0;
}
.article-block-farming {
  @apply flex-1 flex flex-col bg-gradient-tl-primary rounded-lg relative overflow-hidden;
}
.article-block-farming a {
  @apply no-underline text-body flex-1;
  flex-basis: auto;
}
.article-block a {
  @apply no-underline text-body flex-1;
  flex-basis: auto;
}
.article-block-farming__hover {
  @apply absolute inset-y-0 inset-x-0 bg-primary z-10 opacity-0;
}
.article-block-farming:hover {
  @apply cursor-pointer;
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.15);
}
.article-block-farming:hover .article-block-farming__hover {
  @apply opacity-75;
}
.article-block-farming:hover .article-block-farming__shape {
  transform: scale(1.1);
}
.article-block-farming__shape {
  @apply inset-0 absolute opacity-25;
}
.article-block-farming__shape svg {
  @apply absolute bottom-0 right-0 hidden border;
}
.article-block-farming__shape--logo svg {
  @apply block opacity-25 w-full h-full;
}
.article-block-farming h3 {
  @apply text-white mb-12;
}
.article-block-farming__header {
  @apply flex-1 pt-8 pb-8 px-6 z-20 relative;
  flex-basis: auto;
}
.article-block-farming__sharer {
  @apply flex justify-between items-center z-20 relative pb-6 px-6;
}
.article-block-farming__text {
  @apply pr-2 text-white font-semibold;
}
.article-block-farming__button {
  @apply text-secondary;
}
.article-block-farming__button:hover {
  @apply text-primary;
}
@screen md {
  .article-block-farming__header {
    @apply pb-12;
  }
}
</style>
